export default __webpack_public_path__ + "static/media/dev-bd-python-django.2dbb7c45.png";